export const copyReleaseVersion = {
  info: 'Version 2025.2',
  title: 'Develocity version 2025.2 available today',
  subtitle: 'Released July 15th, 2025',
  image: {
    src: '/assets/images/develocity-version.png',
    alt: 'develocity version',
    width: 500,
    height: 300,
  },
  link: {
    href: '/develocity/releases/2025.2',
    text: "See What's New",
  },
};
